/**
 * Mock Aruba keys — exercises the activate-existing branch by default.
 * One key is also `stale: true` so the UI surfaces the re-auth pill.
 */
import type { ArubaKey } from "@/api/schemas/aruba";

export const MOCK_ARUBA_KEYS: ArubaKey[] = [
  {
    id: 1,
    name: "GuestTek · Greenlake prod",
    clientId: "•••• 8c90",
    customerId: "cu-marriott-prod",
    active: false,
    stale: false,
    createdAt: "2026-02-09T11:14:00Z",
    deviceCount: 312,
  },
  {
    id: 2,
    name: "GuestTek · Lab",
    clientId: "•••• 4f02",
    customerId: null,
    active: false,
    stale: true,
    createdAt: "2025-09-21T08:43:00Z",
    deviceCount: 14,
  },
];
